export default "__VITE_ASSET__EmlmXigp__"